import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UtilService } from './util-service';
import { UsuarioService } from './usuario-service';

@Injectable()
export class LoginService {

  constructor(public http: HttpClient,
    private usuarioService: UsuarioService,
  private utilService: UtilService) {
  }

  public autenticarUsuario(jsonObjeto): Observable<any> {
    let urlObtencaoDados: string = "autenticacao/autenticarUsuario";
    return this.utilService.postJSON(urlObtencaoDados, jsonObjeto);
  }


  public autenticarAnalista(jsonObjeto): Observable<any> {
    let urlObtencaoDados: string = "autenticacao/autenticarAnalista";
    return this.utilService.postJSON(urlObtencaoDados, jsonObjeto);
  }

  public autenticarJurisdicionado(jsonObjeto): Observable<any> {
    let urlObtencaoDados: string = "autenticacao/autenticarJurisdicionado";
    return this.utilService.postJSON(urlObtencaoDados, jsonObjeto);
  }

  public setTokenUsuario(token) {
    this.utilService.setToken(token);
  }
}



// WEBPACK FOOTER //
// ./src/providers/login-service.ts